import { styled } from '@mui/system';
const NoWrap = styled('span') `
  white-space: nowrap;
`;
export default NoWrap;
